export default __webpack_public_path__ + "static/media/gpi-icon.f38733e0.webp";